const React = require("react");
const UUID = require("node-uuid");

const HttpResponse = require("./HttpResponse.jsx");

const File = require("../types/File.js");

const styles = {
    List: {
        height: "100%",
        padding: 0,
        paddingLeft: 5,
        listStyle: "none",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
    },
    Item: {
        padding: "10px 0 10px 10px"
    },
    HttpResponse: {
        padding: 10,
        fontSize: 15
    }
};

const UploadFileDetails = React.createClass({
    propTypes: {
        File: File.Type.isRequired
    },
    render() {
        var dataItems = [];

        if (this.props.File.IsUploading) {            
            const startedAt = this.props.File.UploadStartedAt;

            dataItems.push(`Upload started at ${startedAt.format("h:mm:ss A")} on ${startedAt.format("M/D/YY")}.`);
        }

        if (typeof (this.props.File.UploadError) !== "undefined") {
            if (this.props.File.UploadError.response) {
                if(this.props.File.UploadError.response.status === 400) {
                    dataItems.push("The file is invalid.");
                    if (this.props.File.UploadError.message !== "") {
                        dataItems.push(`${this.props.File.UploadError.message}.`);
                    }
                }
                else {
                    dataItems.push("There was a problem processing your request.");
                    dataItems.push(<HttpResponse Response={this.props.File.UploadError.response}
                        style={styles.HttpResponse} />);
                }
            }
            else {
                dataItems.push(`There was a problem with your upload: ${this.props.File.UploadError.message}.`);                
            }

            dataItems.push("Please remove the file from the list, and try it again.  If the error persists, contact support and provide the message above.");
        }

        const listItems = dataItems.map(i => {
            var uid = UUID.v1();

            return (<li key={uid} style={styles.Item }>{i}</li>);
        });

        return (<ul style={styles.List}>
            {listItems}
        </ul>);
    }
});

module.exports = UploadFileDetails;


// WEBPACK FOOTER //
// ./src/components/UploadFileDetails.jsx